import amplitude from 'amplitude-js'
import store from './store'

export async function setAmplitudeEvent (event, data) {
  try {
    const user = store.state.userInfo

    if (process.env.VUE_APP_AMPLITUDE && user && event) {
      const userInfo = {
        'id': user.id,
        'compman': user.compMan.id,
        'role': user.roleGroup.kind
      }
      if (!user.email.includes('lar21@')) {
        const metadata = Object.assign(data, userInfo)
        try {
          const identify = new amplitude.Identify().set('id', userInfo['id']).set('compman', userInfo['compman']).set('role', userInfo['role'])
          amplitude.identify(identify)
          amplitude.getInstance().logEvent(event, metadata)
        } catch (error) {
          console.warn('analytics -> failed to add event')
        }
      } else {
        console.warn('analytics -> user: pontotel')
      }
    } else {
      console.warn('analytics -> env: dev or user: none')
    }
  } catch (err) {
    console.warn('analytics -> failed')
  }
}
